import React, { MutableRefObject } from 'react';
import { Grid } from '@material-ui/core';
import clsx from 'clsx';
import { useSelector } from 'react-redux';

import { StudioControlStyles } from '../styles';
import FontSizeAction from './actions/FontSizeAction';
import ScriptListAction from './actions/ScriptListAction';
import AudioServiceAction from './actions/AudioServiceAction';
import MainStudioActions from '../actions/MainStudioActions';
import { selectIsOpenSettingsPanel } from '../../../store/modules/studio/selectors';

type Props = {
  refPrompter: MutableRefObject<HTMLDivElement | null>;
};

const PrompterSettingsPanel = ({ refPrompter }: Props) => {
  const classes = StudioControlStyles();
  const isOpenSettingsPanel = useSelector(selectIsOpenSettingsPanel);

  return (
    <div hidden={!isOpenSettingsPanel} className={clsx(isOpenSettingsPanel ? classes.panelSettingsContainer : '')}>
      <Grid item container className={classes.panelSettings} spacing={3} alignItems="center">
        <ScriptListAction refPrompter={refPrompter} />
        <FontSizeAction />
        <AudioServiceAction />
      </Grid>
      <MainStudioActions />
    </div>
  );
};

export default PrompterSettingsPanel;
